<template>
<div class="container">
    <div class="text-center display-4">Análisis del Cliente</div>

    <div class="text-center"> Fecha y hora :
        {{ fechaanalisis.getDate()+'/'+ (fechaanalisis.getMonth()+1)+'/'+fechaanalisis.getFullYear() }}
        {{ fechaanalisis.getHours()+':'+fechaanalisis.getMinutes() }}
    </div>

    <b-container>
        <b-row>
            <b-col>
                <div>
                    <h3>{{nombre}}</h3>
                    <p>Rut : {{rut}}</p>
                    <p><strong>Datos de Contacto:</strong> </p> <!-- <button class="btn btn-light" data-placement="top" title="Editar Datos Cliente" data-toggle="modal" data-target="#editarDatosCliente"><i class="fas fa-user-edit"></i></button>-->
                    <p>Dirección: {{direccion}}</p>
                    <p>Teléfono: {{telefono}}</p>
                    <p><strong>Datos Distribuidora</strong> </p> <!-- <button class="btn btn-light" data-placement="top" title="Editar Datos Distribuidora" data-toggle="modal" data-target="#editarDatosDistribuidora"><i class="fas fa-broadcast-tower"></i></button>-->
                    <p>Distribuidora: {{distribuidora}}</p>
                    <p>Potencia: {{potencia}} Tarifa: {{tarifa}}</p>
                    <p>Costo CLP/kWh: {{costoCLP_KWh | formato3}} - Costo CLP/Transporte: {{costoCLP_transporte | formato3}} - Precio Exc {{precioexcedente | formato3}}</p>
                </div>
            </b-col>
            <b-col>
                <!--<img :src="imagen" :alt="nombre">-->
                <h3 class="text-center">Consumo Vs. Generación</h3>
                <line-chart :data="chartData"></line-chart>
            </b-col>
        </b-row>
        <b-row>

            <!-- Datos de consumo -->
            <b-col>
                <div class="text-center display-5 bg-info">
                    <strong>Datos Consumo</strong>
                    <!--<button class="btn btn-info" data-placement="top" title="Editar Datos Consumo" data-toggle="modal" data-target="#editarDatosConsumo"><i class="fas fa-hand-holding-usd"></i></button>-->
                </div>
                <b-table small hover :items="boleta" :fields="fieldsc" class="text-right">

                    <template v-slot:cell(otros)="data">
                        <div v-if="tarifa ==='BT1A'">
                            {{ data.item.cargoTarifario_05+data.item.cargoTarifario_06+data.item.cargoTarifario_07+data.item.cargoTarifario_08 | formato }}
                        </div>
                        <div v-if="tarifa ==='BT1B'">
                            {{ data.item.cargoTarifario_09+data.item.cargoTarifario_10+data.item.cargoTarifario_11 | formato }}
                        </div>
                        <div v-if="tarifa ==='AT2' || tarifa==='BT2'">
                            {{ data.item.cargoTarifario_12| formato }}
                        </div>
                        <div v-if="tarifa ==='AT3' || tarifa==='BT3'">
                            {{ data.item.cargoTarifario_13 | formato }}
                        </div>
                        <div v-if="tarifa ==='AT4.1' || tarifa==='BT4.1'">
                            {{ data.item.cargoTarifario_14+data.item.cargoTarifario_15 | formato }}
                        </div>
                        <div v-if="tarifa ==='AT4.2' || tarifa==='BT4.2'">
                            {{ data.item.cargoTarifario_16+data.item.cargoTarifario_17 | formato }}
                        </div>
                        <div v-if="tarifa ==='AT4.3' || tarifa==='BT4.3'">
                            {{ (data.item.cargoTarifario_01+data.item.cargoTarifario_03+data.item.cargoTarifario_18+data.item.cargoTarifario_19) | formato }}
                        </div>
                    </template>

                </b-table>
                <div class="bg-info">
                    <table class="table table-sm text-right">
                        <tr>
                            <td>Tot</td>
                            <td>{{totalkwc | formato2}}</td>
                            <td>{{totalclpe | formato}}</td>
                            <td>{{totalclpt | formato}}</td>
                            <td>{{totalclpo | formato}}</td>
                        </tr>
                    </table>
                </div>
            </b-col><!-- Datos de consumo -->
            <b-col>
                <!-- Datos de aporte -->
                <div class="text-center display-5 bg-info">
                    <strong>Aporte Solar</strong>
                    <button class="btn btn-info" data-placement="top" title="Editar Datos Aporte" data-toggle="modal" data-target="#editarDatosAporte"><i class="far fa-sun"></i></button>
                </div>
                <b-table small striped hover :items="aporte" :fields="fieldsa">

                    <template v-slot:cell(prorrateo)="data">
                        {{ (data.item.elemento1a / totalkwa) * 100  | formato3 }}
                    </template>

                    <template v-slot:cell(kwa_mes)="data">
                        {{ data.item.elemento1a * tamanoplantacotizar | formato2}}
                    </template>
                </b-table>
                <div class="bg-info">
                    <table class="table table-sm text-left">
                        <tr>
                            <td>Total {{totalkwa | formato2}} kWh/kWp</td>
                            <td>{{totalkwa * tamanoplantacotizar | formato2}} kWh/kWp</td>
                            <td></td>
                            <td></td>
                        </tr>

                    </table>
                </div>
            </b-col><!-- Datos de aporte -->
        </b-row>

        <b-row>
            <!-- Tamaño de Planta Sugerido según los valores registrados-->
            <b-col>
                <div class="text-center">
                    <h3>Tamaño Planta Sugerido: {{Cap | formato3}} kWp <i class="far fa-question-circle" @click="mostrarimagen1=!mostrarimagen1"></i></h3>
                    <div v-if="mostrarimagen1"> <img :src="informacion1" alt="informacion Cap max"></div>
                </div>
            </b-col>
        </b-row> <!-- Tamaño de Planta Sugerido según los valores registrados-->

        <b-row>
            <!-- Tamaño de Planta Sugerido según los valores registrados-->
            <b-col>
                <div class="text-left">
                    <h3>Datos para Evaluación</h3>
                </div>
            </b-col>
        </b-row> <!-- Tamaño de Planta Sugerido según los valores registrados-->

        <b-row>
            <!-- Datos Financieros-->
            <b-col>
                <b-tabs pills content-class="mt-3">
                    <b-tab title="Resultado Preliminar" active class="mb-5 pb-5">
                        <table table-hover class="mb-5 pb-5">
                            <tr>
                                <td>Tamaño Planta a Cotizar Kw</td>
                                <td><input type="number" v-model="tamanoplantacotizar" class="text-right"></td>
                            </tr>
                            <tr>
                                <td>Valor del Dólar Cotizar CLP/U$D</td>
                                <td><input type="number" v-model="valordolarcotizar" class="text-right"> </td>
                            </tr>
                            <tr>
                                <td>Valor Ecer U$D/Wp U$D</td>
                                <td><input type="number" v-model="valorecer" class="text-right"></td>
                            </tr>
                            <tr>
                                <td>
                                    <h4> Valor Total Planta CLP</h4>
                                </td>
                                <td class="text-right">
                                    <h4>{{valortotalplanta | formato}}</h4>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <button class="btn btn-light" @click.prevent="sendEmail"><i class="fas fa-envelope-open-text fa-4x text-danger"></i></button>
                                    <br />Solicitar Cotización formal
                                </td>
                            </tr>
                        </table>
                    </b-tab>
                    <!--  Datos Financieros-->
                </b-tabs>
            </b-col>

            <b-col>
                <b-tabs pills content-class="mt-3">
                    <b-tab title="Antecedentes financieros" active class="mb-5">
                        <table table-hover>
                            <tr>
                                <td>Financiamiento</td>
                                <td>Banco Estado</td>
                            </tr>
                            <tr>
                                <td>Valor Total Planta CLP</td>
                                <td class="text-right">{{valortotalplanta | formato}} </td>
                            </tr>
                            <tr>
                                <td>% PIE</td>
                                <td><input type="number" v-model="pie1" class="text-right deuda" size="10">% <span class="deuda">{{montopie1 | formato }} </span> </td>
                            </tr>
                            <tr>
                                <td>Monto a Financiar CLP</td>
                                <td class="text-right deuda">{{montofinanciamiento1 | formato}} </td>
                            </tr>
                            <tr>
                                <td>% Tasa Banco Estado</td>
                                <td><input type="number" v-model="tasa1" class="text-right" size="10" max="100" min="1">%</td>
                            </tr>
                            <tr>
                                <td>Plazo años</td>
                                <td><input type="number" v-model="plazoanos1" class="text-right" size="10" max="12" min="1"></td>
                            </tr>
                            <tr>
                                <td>Número Cuotas</td>
                                <td><input type="number" v-model="ncuotas1" class="text-right" size="10" readonly></td>
                            </tr>
                            <tr>
                                <td>Monto Cuota Pagar CLP</td>
                                <td class="text-right deuda">{{montopagarcuotas1 | formato3}} </td>
                            </tr>
                        </table>
                        <div>
                            <p>Para conocer la tasa de interés aplicada por el banco,
                            <p>
                                <!--<p>conociendo la cuota mensual, escriba su monto y haga click </p>-->
                            <p><input type="number" v-model="montocuotacalculadaporelbanco" class="text-right deuda" size="10">
                                <button class="btn btn-warning" @click="tasabanco1">Calcular Tasa</button>
                                Tasa Interés banco <span class="deuda" v-if="this.montocuotacalculadaporelbanco>0"><strong> {{tasainteresaplicadaporelbanco | formato3}} % </strong></span>
                            </p>
                        </div>
                    </b-tab>
                </b-tabs>

            </b-col>

        </b-row>

        <!--Antecedentes técnicos -->
        <b-row>
            <b-col>
                <div class="text-left">
                    <h3>Datos Técnicos</h3>
                </div>
            </b-col>
        </b-row>
        <!--Antecedentes técnicos -->
        <b-row>
            <b-col>
                <b-tabs pills content-class="mt-3">
                    <b-tab title="Panel Solar" active class="mb-5">

                        <table class="table table-striped table-bordered">
                            <tr>
                                <td colspan="2">
                                    <b-form-select v-model="panel" :options="traerDataPaneles" class="mb-3" value-field="Item" text-field="Modelo" disabled-field="notEnabled" @change="buscarpanel(panel)"></b-form-select>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="5">
                                    <div v-if="panel!=''">
                                        <img :src="imgreference" alt="imagen referencia panel solar" width="100%">
                                    </div>
                                </td>
                            </tr>

                            <tr>
                                <td>Procedencia</td>
                                <td v-text="procedencia"></td>
                            </tr>
                            <tr>
                                <td>Peso Panel Kg</td>
                                <td v-text="peso"></td>
                            </tr>
                            <tr>
                                <td>Medidas (mm)</td>
                                <td v-text="medidas"></td>
                            </tr>
                            <tr>
                                <td>Potencia panel Wp</td>
                                <td v-text="potenciapanel"></td>
                            </tr>
                            <tr>
                                <td>Rendimiento</td>
                                <td v-text="rendimiento"></td>
                            </tr>
                            <tr>
                                <td>Resolución</td>
                                <td v-text="resolucion"></td>
                            </tr>
                            <tr>
                                <td>Cantidad de Paneles</td>
                                <td>{{ ((tamanoplantacotizar*1000) / potenciapanel ) | formato2}}</td>
                            </tr>
                        </table>
                    </b-tab>
                </b-tabs>
            </b-col>

            <b-col>
                <b-tabs pills content-class="mt-3">
                    <b-tab title="Inversor" active class="mb-5 pb-5">
                        <table class="table table-striped table-bordered">
                            <tr>
                                <td colspan="2">
                                    <b-form-select v-model="inversor" :options="traerDataInversores" class="mb-3" value-field="Item" text-field="Modelo" disabled-field="notEnabled" @change="buscarinversor(inversor)"></b-form-select>
                                </td>
                            </tr>
                            <tr>
                                <td rowspan="5">
                                    <div v-if="inversor!=''">
                                        <img :src="imgreference2" alt="imagen referencia inversor solar" width="100%">
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Procedencia</td>
                                <td v-text="procedencia2"></td>
                            </tr>
                            <tr>
                                <td>Peso Inversor Kg</td>
                                <td v-text="peso2"></td>
                            </tr>
                            <tr>
                                <td>Medidas (mm)</td>
                                <td v-text="medidas2"></td>
                            </tr>
                            <tr>
                                <td>Potencia Inversor Wp</td>
                                <td v-text="potenciainversor"></td>
                            </tr>
                            <tr>
                                <td>Rendimiento</td>
                                <td v-text="rendimiento2"></td>
                            </tr>
                            <tr>
                                <td>Resolución</td>
                                <td v-text="resolucion2"></td>
                            </tr>

                        </table>
                    </b-tab>
                </b-tabs>
            </b-col>
        </b-row>
        <!--Antecedentes técnicos -->
        <b-row class="mb-5">
            <b-col>
                <table>
                    <tr>
                        <td colspan="6">Instalado en

                            <b-form-select v-model="lugarinstalacion" :options="lugarinstalacionvalores" value-field="lugar" text-field="lugar" class="mb-3" disabled-field="notEnabled" @change="buscarfactor(lugarinstalacion)"></b-form-select>

                        </td>

                        <td rowspan="3">
                            <div v-if="panel!=''">
                                <img :src="imgreferencelugar" alt="imagen referencia lugar instalación" width="40%">
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td>Factor</td>
                        <td v-text="factor"></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Área aproximada</td>
                        <td>{{areaaproximada | formato2}} mts</td>
                        <td></td>
                        <td></td>
                    </tr>

                </table>

            </b-col>
        </b-row>
        <!-- Balance-->
        <b-row>
            <b-col>
                <div class="text-center display-5 bg-info"><strong class="display-4">Balance</strong> </div>
                <div>
                    <table class="table table-sm text-center">
                        <tr>
                            <td>...</td>
                            <td colspan="2">Autoconsumo</td>
                            <td colspan="2">Excedentes</td>
                            <!--<td colspan="2">Balance Mensual</td>-->
                        </tr>
                    </table>
                </div>
                <b-table small striped hover :items="balance" :fields="fieldsbalance" class=" text-right">

                </b-table>
                <div>
                    <table class="table table-sm text-right  bg-info">
                        <tr>
                            <td>Tot</td>
                            <td>{{sumacol_1 | formato2}}</td>
                            <td>{{sumacol_2 | formato}}</td>
                            <td>{{sumacol_3 | formato2}}</td>
                            <td>{{sumacol_4 | formato}}</td>
                            <!--<td>{{sumacol_5 | formato2}}</td><td>{{sumacol_6 | formato}}</td>-->
                        </tr>
                    </table>
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <!-- inicio tabla  Cuadro de Balance-->
                <div class="text-center display-5 bg-info mt-5"><strong class="display-4">Flujo de Caja</strong> </div>
                <table class="table mt-5">
                    <tr>
                        <td>1.- Consumo Eléctrico KWh + Tx</td>
                        <td class="text-right text-danger"><strong> {{this.balance1 | formato3}} </strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>2.- Consumo Eléctrico Otros Items</td>
                        <td class="text-right text-danger"><strong>{{this.balance2 | formato3}}</strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-right">SUMA CONSUMOS ELECTRICOS Y OTROS ITEMS</td>
                        <td></td>
                        <td class="text-right text-danger"><strong><u>{{this.balance1 + this.balance2 | formato3}}</u></strong></td>
                    </tr>
                    <tr>
                        <td>Ahorro Planta FV AutoConsumo(+)</td>
                        <td class="text-right text-info"><strong>{{this.balance3 | formato3}}</strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td>Ahorro Planta FV Excedentes(+)</td>
                        <td class="text-right text-info"><strong>{{this.balance4 | formato3}}</strong></td>
                        <td></td>
                    </tr>
                    <tr>
                        <td class="text-right">3.- SUMA AUTOCONSUMO + EXCEDENTES</td>
                        <td></td>
                        <td class="text-right text-info"><strong><u>{{this.balance5 | formato3}}</u> </strong></td>
                    </tr>
                    <tr>
                        <td>4.- NUEVA CUENTA (1 + 2 - 3)</td>
                        <td></td>
                        <td class="text-right">{{this.balance6 | formato3}}</td>
                    </tr>
                    <tr>
                        <td>5.- CUOTA ANNUAL LEASING (-)</td>
                        <td></td>
                        <td class="text-right">{{this.balance7 | formato3}}</td>
                    </tr>
                    <tr>
                        <td>6.- BALANCE GENERAL</td>
                        <td></td>
                        <td class="text-right"><strong><u>{{this.balance8 | formato3}}</u></strong></td>
                    </tr>
                </table>

                <!--fin tabla  Cuadro de Balance-->
            </b-col>
        </b-row>
        <!-- Balance-->
        <b-row>
            <b-col>
                <div class="text-right">
                    <button class="btn btn-primary" @click.prevent="guardarAnalisis">Guardar</button>
                </div>
            </b-col>
        </b-row>
        <!--grafico -->
        <b-row class="my-5">
            <b-col>
                <div class="text-center">
                    <h3>Gráfico Flujo de Caja</h3>
                </div>
                <column-chart :data="chartData2"></column-chart>
            </b-col>
        </b-row>

    </b-container>

</div>
</template>

<script>
import imageninformacion1 from '../assets/Capmax.png';
import accouting from 'accounting';
import Swal from 'sweetalert2';
import emailjs from 'emailjs-com';

// *** calculo cuota pago 
var DIARIO = "diario";
var SEMANAL = "semanal";
var QUINCENAL = "quincenal";
var MENSUAL = "mensual";
var BIMESTRAL = "bimestral";
var TRIMESTRAL = "trimestral";
var CUATRIMESTRAL = "cuatrimestral";
var SEMESTRAL = "semestral";
var ANUAL = "anual";

export default {
    name: 'Analisis',
    components: {

    },
    data() {
        return {
            fieldsc: [{
                    key: 'mes',
                    label: 'Mes',
                    //sortable: true,
                },
                {
                    key: 'kwconsumo',
                    label: 'kWh',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 0, '.', ',');
                    }
                },
                {
                    key: 'cargoTarifario_04',
                    label: '$Energía',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                },
                {
                    key: 'cargoTarifario_02',
                    label: '$Transporte',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                },
                {
                    key: 'otros',
                    label: '$Otros',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                }
            ],
            fieldsa: [{
                    key: 'mes',
                    label: 'Mes',
                    //sortable: true,
                },
                {
                    key: 'elemento1a',
                    label: '1 kWh/kWp ',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 0, '.', ',');
                    }
                },
                {
                    key: 'prorrateo',
                    label: 'Prorrateo %',
                    //variant:'info'
                },
                {
                    key: 'kwa_mes',
                    label: 'kWh aporte mes ',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 0, '.', ',');
                    }
                }
            ],
            fieldsbalance: [{
                    key: 'elmes',
                    label: 'Mes',
                    //sortable: true,
                },
                {
                    key: 'columna1',
                    label: 'Kwh',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 0, '.', ',');
                    }
                },
                {
                    key: 'columna2',
                    label: 'CLP',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                },
                {
                    key: 'columna3',
                    label: 'Kwh',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 0, '.', ',');
                    }
                },
                {
                    key: 'columna4',
                    label: 'CLP',
                    formatter: value => {
                        return accouting.formatMoney(value, '', 2, '.', ',');
                    }
                },
            ],

            fechaanalisis: new Date(),
            cambio: 0, //variable cambio 
            idDoc: '',
            nombre: '',
            rut: '',
            direccion: '',
            fp: 0,
            telefono: '',
            distribuidora: '',
            potencia: '',
            tarifa: '',
            costoCLP_KWh: 0,
            costoCLP_transporte: 0,
            precioexcedente: 0,
            boleta: [],
            aporte: [],
            balance: [],
            valoreskwc: [],
            valoreskwa: [],
            totalkwc: 0,
            totalkwa: 0,
            totalclpe: 0,
            totalclpt: 0,
            totalclpo: 0,
            tamanoplanta: 0,
            imagen: '',
            chartData: {},
            chartData2: {},
            Fn: 0,
            Cap: 0,
            informacion1: imageninformacion1,
            mostrarimagen1: false,
            tamanoplantacotizar: 0,
            valordolarcotizar: 0,
            valorecer: 1.2,
            valortotalplanta: 0,
            pie1: 20,
            montopie1: 0,
            montofinanciamiento1: 0,
            tasa1: 7,
            plazoanos1: 12,
            ncuotas1: 0,
            periodo: "mensual",
            tasa_tipo: "anual",
            montopagarcuotas1: 0,
            montocuotacalculadaporelbanco: 0,
            tasainteresaplicadaporelbanco: 0,
            //balance 
            col_1: 0, // kw
            col_2: 0, //clp  kw*(costokw+costotransporte)
            col_3: 0, //Kw excedente 
            col_4: 0, //kw excedente * precio excedente
            col_5: 0, //diferencia kwaporte - kwconsumo
            col_6: 0, // suma clp
            sumacol_1: 0, // kw
            sumacol_2: 0, //clp  kw*(costokw+costotransporte)
            sumacol_3: 0, //Kw excedente 
            sumacol_4: 0, //kw excedente * precio excedente
            sumacol_5: 0, //diferencia kwaporte - kwconsumo
            sumacol_6: 0, // suma clp
            balance1: 0,
            balance2: 0,
            balance3: 0,
            balance4: 0,
            balance5: 0,
            balance6: 0,
            balance7: 0,
            balance8: 0,
            panel: '',
            inversor: '',
            panelseleccionado: {},
            inversorseleccionado: {},
            lugarseleccionado: {},
            peso: 0,
            peso2: 0,
            medidas: '',
            medidas2: '',
            potenciapanel: 0,
            potenciainversor: 0,
            imgreference: '',
            imgreference2: '',
            imgreferencelugar: '',
            factor: '',
            procedencia: '',
            procedencia2: '',
            rendimiento: '',
            rendimiento2: '',
            resolucion: '',
            resolucion2: '',
            areaaproximada: 0,
            lugarinstalacion: '',
            lugarinstalacionvalores: [{
                    lugar: 'Piso',
                    valorfactor: 15,
                    imagen: 'https://investchile.gob.cl/wp-content/uploads/2017/07/quilapilun-5-1010x578.jpeg'
                },
                {
                    lugar: 'Techo Coplanar',
                    valorfactor: 10,
                    imagen: 'https://revolucionrenovable.files.wordpress.com/2019/11/energia-limpia-xxi-universidad-de-vic391a-del-mar-foto-seremi-1.png?w=696&h=450&crop=1'
                },
                {
                    lugar: 'Techo c/Estructura',
                    valorfactor: 17,
                    imagen: 'https://cdn.lavoz.com.ar/sites/default/files/styles/width_1072/public/nota_periodistica/panel-solar-ecovatio.jpg'
                }
            ],
            YOURSERVICEID: 'gmail',
            YOURTEMPLATEID: 'template_8y8c41b',
            YOURUSERID: 'user_YuhCBzECQupe74nEvDgrQ',
            cadenamensaje: '',
            cadenamensaje2: '',
            cadenamensaje3: ''
        }
    },
    computed: {
        traerDataPaneles() {
            return this.$store.getters.enviarDataPaneles;
        },
        traerDataInversores() {
            return this.$store.getters.enviarDataInversores;
        }

    },
    mounted() {
        emailjs.init(this.YOURUSERID);

        if (parseInt(this.$route.params.id) >= 0) {
            this.$store.getters.enviarDataClientes[this.$route.params.id];

            this.datosCliente();

            //this.rut = this.$store.getters.enviarDataClientes[this.$route.params.id].rut;
            this.datosDistribuidora();
            this.boleta = this.$store.getters.enviarDataClientes[this.$route.params.id].boleta;
            this.aporte = this.$store.getters.enviarDataClientes[this.$route.params.id].aporte;
            //this.imagen = this.$store.getters.enviarDataClientes[this.$route.params.id].imgurl;
            this.valordolarcotizar = this.$store.getters.enviarDataClientes[this.$route.params.id].valordolar;

            this.tablaconsumo();
            this.tablaaporte();

            //Llenar Balance
            this.tablabalance(this.tamanoplantacotizar);
            this.getflujocaja();

            //grafico 
            this.graficolineas(this.tamanoplanta);

            this.chartData2 = [{
                name: "Flujo de Caja",
                data: {
                    'CONSUMO ELECTRICO KWh + Tx': this.balance1,
                    'CONSUMO ELECTRICO OTROS ITEMS': this.balance2,
                    'SUMA AUTOCONSUMO + EXCEDENTES': this.balance5,
                    'NUEVA CUENTA': this.balance6,
                    'CUOTA ANNUAL LEASING (-)': this.balance7,
                    'BALANCE GENERAL': this.balance8
                }
            }]

        }
    },
    methods: {
        buscarpanel(panel) {
            this.panelseleccionado = this.traerDataPaneles.filter((element) => {
                return element.Item.includes(panel)
            });
            this.procedencia = this.panelseleccionado[0].Procedencia;
            this.rendimiento = this.panelseleccionado[0].Rendimiento;
            this.resolucion = this.panelseleccionado[0].Resolucion;
            this.peso = this.panelseleccionado[0].Peso;
            this.medidas = this.panelseleccionado[0].Dimensiones;
            this.potenciapanel = this.panelseleccionado[0].Potencia;
            this.imgreference = 'https://i.linio.com/p/40514b0de76918c813083bb8b70ea32e-zoom.webp';
            //console.log(this.panelseleccionado.peso);            
        },
        buscarinversor(inversor) {
            this.inversorseleccionado = this.traerDataInversores.filter((element) => {
                return element.Item.includes(inversor)
            });
            this.procedencia2 = this.inversorseleccionado[0].Procedencia;
            this.rendimiento2 = this.inversorseleccionado[0].Rendimiento;
            this.resolucion2 = this.inversorseleccionado[0].Resolucion;
            this.peso2 = this.inversorseleccionado[0].Peso;
            this.medidas2 = this.inversorseleccionado[0].Dimensiones;
            this.potenciainversor = this.inversorseleccionado[0].Potencia;
            this.imgreference2 = 'https://i.linio.com/p/a5894de4a400b2a66ed6919f959ab793-zoom.webp';
        },
        buscarfactor(lugar) {
            this.lugarseleccionado = this.lugarinstalacionvalores.filter((element) => {
                return element.lugar.includes(lugar)
            });
            this.factor = this.lugarseleccionado[0].valorfactor;
            this.imgreferencelugar = this.lugarseleccionado[0].imagen;
            this.areaaproximada = ((this.tamanoplantacotizar * this.factor))

        },

        datosCliente() {
            this.nombre = this.$store.getters.enviarDataClientes[this.$route.params.id].nombre;
            this.direccion = this.$store.getters.enviarDataClientes[this.$route.params.id].direccion;
            this.fp = this.$store.getters.enviarDataClientes[this.$route.params.id].fp;
            this.rut = this.$store.getters.enviarDataClientes[this.$route.params.id].rut;
            this.telefono = this.$store.getters.enviarDataClientes[this.$route.params.id].telefono;
            this.idDoc = this.$store.getters.enviarDataClientes[this.$route.params.id].idDoc;
        },
        datosDistribuidora() {
            this.distribuidora = this.$store.getters.enviarDataClientes[this.$route.params.id].distribuidora;
            this.potencia = this.$store.getters.enviarDataClientes[this.$route.params.id].potencia;
            this.tarifa = this.$store.getters.enviarDataClientes[this.$route.params.id].tarifa;
            this.costoCLP_KWh = this.$store.getters.enviarDataClientes[this.$route.params.id].costoCLP_KWh; //costo Kw
            this.costoCLP_transporte = this.$store.getters.enviarDataClientes[this.$route.params.id].costoCLP_transporte; //costo transporte
            this.precioexcedente = this.$store.getters.enviarDataClientes[this.$route.params.id].precioCLP_excedente; //precio excedente
        },
        tablaconsumo() {
            for (let i = 0; i < 12; i++) {
                this.valoreskwc.push(this.boleta[i].kwconsumo)

                //sumas
                this.totalclpe += this.boleta[i].cargoTarifario_04;
                this.totalclpt += this.boleta[i].cargoTarifario_02;
                if (this.tarifa === 'BT1A') {
                    this.totalclpo += this.boleta[i].cargoTarifario_05 + this.boleta[i].cargoTarifario_06 + this.boleta[i].cargoTarifario_07 + this.boleta[i].cargoTarifario_08;
                }
                if (this.tarifa === 'BT1B') {
                    this.totalclpo += this.boleta[i].cargoTarifario_09 + this.boleta[i].cargoTarifario_10 + this.boleta[i].cargoTarifario_11;
                }
                if (this.tarifa === 'AT2' || this.tarifa === 'BT2') {
                    this.totalclpo += this.boleta[i].cargoTarifario_12;
                }
                if (this.tarifa === 'AT3' || this.tarifa === 'BT3') {
                    this.totalclpo += this.boleta[i].cargoTarifario_13;
                }
                if (this.tarifa === 'AT4.1' || this.tarifa === 'BT4.1') {
                    this.totalclpo += this.boleta[i].cargoTarifario_14 + this.boleta[i].cargoTarifario_15;
                }
                if (this.tarifa === 'AT4.2' || this.tarifa === 'BT4.2') {
                    this.totalclpo += this.boleta[i].cargoTarifario_16 + this.boleta[i].cargoTarifario_17;
                }
                if (this.tarifa === 'AT4.3' || this.tarifa === 'BT4.3') {
                    this.totalclpo += this.boleta[i].cargoTarifario_18 + this.boleta[i].cargoTarifario_19;
                }
            }
            this.totalkwc = this.valoreskwc.reduce((a, b) => a + b); //suma kwc
        },
        tablaaporte() {
            for (let i = 0; i < 12; i++) {
                this.valoreskwa.push(this.aporte[i].elemento1a)
            }
            this.totalkwa = this.valoreskwa.reduce((a, b) => a + b); //suma kwa
            this.tamanoplanta = this.totalkwc / this.totalkwa

            this.Fn = (parseFloat(this.totalclpe) + parseFloat(this.totalclpt) + parseFloat(this.totalclpo));

            this.Cap = parseFloat(this.Fn) / ((parseFloat(this.costoCLP_KWh) + parseFloat(this.costoCLP_transporte)) * (parseFloat(this.fp / 100)) * 8760)
            this.tamanoplanta = this.Cap;

            this.tamanoplantacotizar = this.Cap.toFixed(2) // Tamaño Planta Sugerido === Tamaño Planta Cotizar 
            this.valortotalplanta = (this.tamanoplantacotizar * 1000) * this.valordolarcotizar * this.valorecer

            this.montopie1 = this.valortotalplanta * (this.pie1 / 100);
            this.montofinanciamiento1 = this.valortotalplanta - this.montopie1;
            this.ncuotas1 = this.plazoanos1 * 12;

            this.getValorDeCuotaFija(this.montofinanciamiento1, this.tasa1, this.ncuotas1, this.periodo, this.tasa_tipo);
        },
        tablabalance(tamano) {

            this.balance = [];
            this.sumacol_1 = 0; // kw
            this.sumacol_2 = 0; //clp  kw*(costokw+costotransporte)
            this.sumacol_3 = 0; //Kw excedente 
            this.sumacol_4 = 0; //kw excedente * precio excedente
            this.sumacol_5 = 0; //diferencia kwaporte - kwconsumo
            this.sumacol_6 = 0; // suma clp

            for (let i = 0; i < 12; i++) {
                this.col_1 = this.boleta[i].kwconsumo
                if (this.boleta[i].kwconsumo > ((this.aporte[i].elemento1a) * tamano)) {
                    this.col_1 = this.aporte[i].elemento1a * tamano
                }

                this.col_2 = (this.costoCLP_KWh + this.costoCLP_transporte) * this.col_1 //  CLP
                if (((this.aporte[i].elemento1a) * tamano) > this.boleta[i].kwconsumo) {
                    this.col_3 = ((this.aporte[i].elemento1a) * tamano) - this.boleta[i].kwconsumo;
                    this.col_4 = (((this.aporte[i].elemento1a) * tamano) - this.boleta[i].kwconsumo) * this.precioexcedente;
                } else {
                    this.col_3 = 0;
                    this.col_4 = 0;
                }
                this.col_5 = ((this.aporte[i].elemento1a) * tamano) - this.boleta[i].kwconsumo;
                this.col_6 = (this.col_2 + this.col_4) - (this.boleta[i].cargoTarifario_02 + this.boleta[i].cargoTarifario_04);

                //   //array
                let auxiliarbalance = {
                    elmes: this.boleta[i].mes,
                    columna1: this.col_1,
                    columna2: this.col_2,
                    columna3: this.col_3,
                    columna4: this.col_4,
                    columna5: this.col_5,
                    columna6: this.col_6
                }
                this.balance.push(auxiliarbalance);

                //Totales
                this.sumacol_1 += this.col_1
                this.sumacol_2 += this.col_2
                this.sumacol_3 += this.col_3
                this.sumacol_4 += this.col_4
                this.sumacol_5 += this.col_5
                this.sumacol_6 += this.col_6
                //Totales

                //flujo de caja             
            }
        },
        getflujocaja() {
            this.balance1 = -(this.totalclpe + this.totalclpt);
            this.balance2 = -(this.totalclpo);
            this.balance3 = this.sumacol_2;
            this.balance4 = this.sumacol_4;
            this.balance5 = this.balance3 + this.balance4;
            this.balance6 = (this.balance1 + this.balance2) + this.balance5;
            this.balance7 = -this.montopagarcuotas1 * 12;
            this.balance8 = this.balance5 + this.balance6 + this.balance7;
        },
        graficolineas(tamano) {

            this.chartData = [{
                    name: "consumo",
                    data: {
                        'Ene': this.valoreskwc[0],
                        'Feb': this.valoreskwc[1],
                        'Mar': this.valoreskwc[2],
                        'Abr': this.valoreskwc[3],
                        'May': this.valoreskwc[4],
                        'Jun': this.valoreskwc[5],
                        'Jul': this.valoreskwc[6],
                        'Ago': this.valoreskwc[7],
                        'Sep': this.valoreskwc[8],
                        'Oct': this.valoreskwc[9],
                        'Nov': this.valoreskwc[10],
                        'Dic': this.valoreskwc[11],
                    }
                },
                {
                    name: "aporte",
                    data: {
                        'Ene': this.valoreskwa[0] * tamano,
                        'Feb': this.valoreskwa[1] * tamano,
                        'Mar': this.valoreskwa[2] * tamano,
                        'Abr': this.valoreskwa[3] * tamano,
                        'May': this.valoreskwa[4] * tamano,
                        'Jun': this.valoreskwa[5] * tamano,
                        'Jul': this.valoreskwa[6] * tamano,
                        'Ago': this.valoreskwa[7] * tamano,
                        'Sep': this.valoreskwa[8] * tamano,
                        'Oct': this.valoreskwa[9] * tamano,
                        'Nov': this.valoreskwa[10] * tamano,
                        'Dic': this.valoreskwa[11] * tamano,
                    }
                },
            ]
        },

        sumar() {
            console.log(this.consumo.length);
            for (let i = 0; i < this.consumo.length; i++) {
                this.totalkwc += this.consumo[0].elemento1;
                console.log(this.consumo[i].elemento1);
            }
            console.log(this.totalkwc);
            console.log(this.tamanoplanta);
        },
        getValorDeCuotaFija(monto, tasa, cuotas, periodo, tasa_tipo) {
            tasa = this.getTasa(tasa, tasa_tipo, periodo);
            this.montopagarcuotas1 = monto * ((tasa * Math.pow(1 + tasa, cuotas)) / (Math.pow(1 + tasa, cuotas) - 1));
            return this.montopagarcuotas1;
        },
        getTasa(tasa, tasa_tipo, periodo) {
            if (tasa_tipo == ANUAL) {
                tasa = tasa / 12
            }
            tasa = tasa / 100.0
            if (periodo == DIARIO) {
                tasa = tasa / 30.4167
            }
            if (periodo == SEMANAL) {
                tasa = tasa / 4.34524
            }
            if (periodo == QUINCENAL) {
                tasa = tasa / 2
            }
            if (periodo == MENSUAL) {
                tasa = tasa / 1
            }
            if (periodo == BIMESTRAL) {
                tasa = tasa * 2
            }
            if (periodo == TRIMESTRAL) {
                tasa = tasa * 3
            }
            if (periodo == CUATRIMESTRAL) {
                tasa = tasa * 4
            }
            if (periodo == SEMESTRAL) {
                tasa = tasa * 6
            }
            if (periodo == ANUAL) {
                tasa = tasa * 12
            }
            return tasa;
        },

        //rate(periods, payment, present, future, type, guess) {
        tasabanco1() {
            let periods = parseFloat(this.ncuotas1);
            let payment = -parseFloat(this.montocuotacalculadaporelbanco);
            let present = parseFloat(this.montofinanciamiento1);
            let guess = (guess === undefined) ? 0.01 : guess;
            let future = (future === undefined) ? 0 : future;
            let type = (type === undefined) ? 0 : type;

            // Set maximum epsilon for end of iteration
            var epsMax = 1e-10;

            // Set maximum number of iterations
            var iterMax = 10;

            // Implement Newton's method
            var y, y0, y1, x0, x1 = 0,
                f = 0,
                i = 0;
            var rate = guess;
            if (Math.abs(rate) < epsMax) {
                y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
            } else {
                f = Math.exp(periods * Math.log(1 + rate));
                y = present * f + payment * (1 / rate + type) * (f - 1) + future;
            }
            y0 = present + payment * periods + future;
            y1 = present * f + payment * (1 / rate + type) * (f - 1) + future;
            i = x0 = 0;
            x1 = rate;
            while ((Math.abs(y0 - y1) > epsMax) && (i < iterMax)) {
                rate = (y1 * x0 - y0 * x1) / (y1 - y0);
                x0 = x1;
                x1 = rate;
                if (Math.abs(rate) < epsMax) {
                    y = present * (1 + periods * rate) + payment * (1 + rate * type) * periods + future;
                } else {
                    f = Math.exp(periods * Math.log(1 + rate));
                    y = present * f + payment * (1 / rate + type) * (f - 1) + future;
                }

                y0 = y1;
                y1 = y;
                ++i;
            }
            this.tasainteresaplicadaporelbanco = rate * 100 * 12;
            return rate;
        },
        guardarAnalisis() {
            // validar los datos  antes de guardar y se preguntara 

            if (!this.tamanoplantacotizar && !this.valordolarcotizar && !this.valorecer && !this.pie1 && this.tasa1 && !this.plazoanos1 && !this.panel && !this.inversor && !this.lugarinstalacion) {
                Swal.fire("Escriba los valores de análisis")
            } else {
                Swal.fire({
                    title: 'Se guardará el análisis ?',
                    text: this.nombre,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Si, guardar'
                }).then((result) => {
                    if (result.value) {
                        let mifecha = this.fechaanalisis.getDate() + '/' + (this.fechaanalisis.getMonth() + 1) + '/' + this.fechaanalisis.getFullYear() + ' ' + this.fechaanalisis.getHours() + ':' + this.fechaanalisis.getMinutes();

                        let auxiliarAnalisis = {
                            idDoc: this.idDoc,
                            idCliente: this.idDoc,
                            fecha: mifecha,
                            tamanoplantacotizar: parseFloat(this.tamanoplantacotizar),
                            valordolarcotizar: parseFloat(this.valordolarcotizar),
                            valorecer: this.valorecer,
                            pie: this.pie1,
                            tasa: this.tasa1,
                            plazoanos: this.plazoanos1,
                            panel: this.panel,
                            inversor: this.inversor,
                            lugarinstalacion: this.lugarinstalacion
                        }
                        this.$store.dispatch('guardarAnalisis', auxiliarAnalisis);
                    }
                })
            }
        },
        sendEmail() {
            Swal.fire({
                title: 'Se enviará Email a Banco Estado ',
                text: 'para solicitar cotización formal ',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, enviar'
            }).then((result) => {
                if (result.value) {
                    this.cadenamensaje = 'Estimado: XXX ';
                    this.cadenamensaje2 = 'Estimado: XXX 2  ';
                    this.cadenamensaje3 = 'Estimado: XXX 3 ';

                    let templateParams = {
                        dia: this.fechaanalisis.getDate(),
                        mes: (this.fechaanalisis.getMonth() + 1),
                        ano: this.fechaanalisis.getFullYear(),
                        from_rut: this.rut,
                        to_name: 'Sres: Banco Estado',
                        from_name: this.nombre,
                        potencia: this.potencia,
                        valor: this.valortotalplanta,
                        anos: this.plazoanos1,
                        pie: this.pie1,

                    };
                    emailjs.send(this.YOURSERVICEID, this.YOURTEMPLATEID, templateParams, this.YOURUSERID)
                        .then((response) => {
                            console.log('SUCCESS!', response.status, response.text);
                            Swal.fire("Email enviado");
                        }, (err) => {
                            console.log('FAILED...', err);
                            Swal.fire("Error enviando Email");
                        });
                }
            })
        }

    },
    watch: {
        tamanoplantacotizar() {
            this.valortotalplanta = (this.tamanoplantacotizar * 1000) * this.valordolarcotizar * this.valorecer;
            this.montopie1 = this.valortotalplanta * (this.pie1 / 100);
            this.montofinanciamiento1 = this.valortotalplanta - this.montopie1;
            this.getValorDeCuotaFija(this.montofinanciamiento1, this.tasa1, this.ncuotas1, this.periodo, this.tasa_tipo);
            this.tablabalance(this.tamanoplantacotizar);
            this.getflujocaja();
            this.graficolineas(this.tamanoplantacotizar);

        },
        valordolarcotizar() {
            this.valortotalplanta = (this.tamanoplantacotizar * 1000) * this.valordolarcotizar * this.valorecer;
        },
        valorecer() {
            this.valortotalplanta = (this.tamanoplantacotizar * 1000) * this.valordolarcotizar * this.valorecer;
            this.getflujocaja();
        },
        pie1() {
            this.montopie1 = this.valortotalplanta * (this.pie1 / 100);
            this.montofinanciamiento1 = this.valortotalplanta - this.montopie1;
            this.getValorDeCuotaFija(this.montofinanciamiento1, this.tasa1, this.ncuotas1, this.periodo, this.tasa_tipo);
            this.getflujocaja();
        },
        plazoanos1() {
            this.ncuotas1 = this.plazoanos1 * 12;
            this.getValorDeCuotaFija(this.montofinanciamiento1, this.tasa1, this.ncuotas1, this.periodo, this.tasa_tipo);
            this.tasabanco1();
            this.getflujocaja();
        },
        tasa1() {
            this.getValorDeCuotaFija(this.montofinanciamiento1, this.tasa1, this.ncuotas1, this.periodo, this.tasa_tipo);
            this.getflujocaja();
        },
        getflujocaja() {
            this.balance1 = -(this.totalclpe + this.totalclpt);
            this.balance2 = this.totalclpo;
            this.balance3 = this.sumacol_2;
            this.balance4 = this.sumacol_4;
            this.balance5 = this.balance3 + this.balance4;
            this.balance6 = this.balance1 + this.balance5;
            this.balance7 = -this.montopagarcuotas1 * 12;
            this.balance8 = this.balance5 + this.balance6 + this.balance7;
        }

    }

}
</script>

<style lang="scss" scoped>
#datoscliente {
    background-color: #bfe3b8;
}

.deuda {
    color: red;
}

// .tablabalance {
//   font-size: 14px;
//   margin-left: auto;
//   margin-right: auto;
//   width: 400px;
// }
</style>
